"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotion = require("emotion");

var _pie = _interopRequireDefault(require("@amzn/meridian-tokens/component/pie"));

var _theme = require("../theme");

var _useDataVisualization2 = _interopRequireDefault(require("../_use-data-visualization"));

var _angle = require("./../_utils/angle");

var _token = require("./../_utils/token");

var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var width = _ref.width,
      donutRatio = _ref.donutRatio,
      border = _ref.border;
  return (0, _emotion.css)({
    // Container styles
    width: width,
    height: width,
    boxSizing: "border-box",
    position: "relative",
    fontFamily: t("labelFontFamily"),
    color: t("labelColor"),
    fontWeight: t("labelWeight"),
    "& > svg": {
      overflow: "visible",
      // HACK: This fixes weird clipping issues in some versions of Chrome
      transform: "translateZ(0)"
    },
    // Slice styles
    "& > svg path": {
      transition: "all ".concat(t("dataMotionDuration"), " ").concat(t("dataMotionFunction")),
      stroke: border ? (0, _token.getToken)(t.tokens, "themeBackground", [border, "default"]) : "inherit",
      strokeWidth: border ? t("dataBorderWidth") * 0.01 : "inherit"
    },
    // Children outer wrapper styles
    "& > div": {
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      padding: "".concat((100 - donutRatio * 100) / 2, "%"),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      pointerEvents: "none"
    },
    // Children inner wrapper styles
    "& > div > *": {
      pointerEvents: "all"
    }
  });
}, ["width", "donutRatio", "border"]);
var clickablePathStyles = (0, _emotion.css)({
  cursor: "pointer"
});
/**
 * Return the SVG path necessary to draw a slice.
 */

var getSlicePath = function getSlicePath(_ref2) {
  var startAngle = _ref2.startAngle,
      endAngle = _ref2.endAngle,
      innerRadius = _ref2.innerRadius,
      outerRadius = _ref2.outerRadius;
  // Calculate points along the outside of the slice
  var outerStartX = outerRadius * (0, _angle.cos)(startAngle);
  var outerStartY = outerRadius * (0, _angle.sin)(startAngle);
  var outerEndX = outerRadius * (0, _angle.cos)(endAngle);
  var outerEndY = outerRadius * (0, _angle.sin)(endAngle); // Calculate points along the inside of the slice (only used for donuts)

  var innerStartX = innerRadius * (0, _angle.cos)(startAngle);
  var innerStartY = innerRadius * (0, _angle.sin)(startAngle);
  var innerEndX = innerRadius * (0, _angle.cos)(endAngle);
  var innerEndY = innerRadius * (0, _angle.sin)(endAngle); // Tells SVG to sweep the large arc for slices > 50% or the small arc for
  // slices <= 50%

  var largeArcFlag = endAngle - startAngle > 180 ? 1 : 0; // Put it all together as SVG path data

  return [// Start at a point on the outer edge
  "M ".concat(outerStartX, " ").concat(outerStartY), // Arc to another point on the outer edge that'll give us the desired percent
  "A ".concat(outerRadius, " ").concat(outerRadius, " 0 ").concat(largeArcFlag, " 1 ").concat(outerEndX, " ").concat(outerEndY), // Connect the outer edge to the inner edge
  innerRadius > 0 ? // Line to the start of the inner arc if we're a donut
  "L ".concat(innerEndX, " ").concat(innerEndY) : // Line to the very center if we're a pie & not a donut
  "L 0 0", // Line to the end of the inner arc if we're a donut
  innerRadius > 0 ? "A ".concat(innerRadius, " ").concat(innerRadius, " 0 ").concat(largeArcFlag, " 0 ").concat(innerStartX, " ").concat(innerStartY) : "", // Line back out to the first point
  "L ".concat(outerStartX, " ").concat(outerStartY), "Z"].join(" ");
};

var Pie = function Pie(props) {
  var t = (0, _theme.useTheme)(_pie["default"], "pie");

  var _useDataVisualization = (0, _useDataVisualization2["default"])(props),
      data = _useDataVisualization.data,
      legend = _useDataVisualization.legend;

  var totalValue = data.reduce(function (total, item) {
    return total + item.value;
  }, 0);
  var paths = data.reduce(function (_ref3, item) {
    var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
        details = _ref4[0],
        currentPercent = _ref4[1];

    var itemPercent = item.value / totalValue;
    var path = getSlicePath({
      startAngle: 360 * currentPercent,
      endAngle: 360 * (currentPercent + itemPercent),
      innerRadius: props.donutRatio,
      outerRadius: legend ? t("dataScale", legend.getState(item.key)) / 100 : 1
    });
    details[item.key] = path;
    return [details, currentPercent + itemPercent];
  }, [{}, 0])[0]; // Get the describedby id in the following order of preference
  // - legend aria-describedby
  // - props aria-describedby
  // - legend id

  var describedby = legend && legend["aria-describedby"] ? legend["aria-describedby"] : props["aria-describedby"] ? props["aria-describedby"] : legend && legend.id;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: styles(t, props),
    "mdn-text": "",
    role: "img",
    "aria-describedby": describedby,
    "aria-labelledby": legend && legend["aria-labelledby"] || props["aria-labelledby"],
    "aria-label": legend && legend["aria-label"] || props["aria-label"],
    title: legend && legend["aria-label"] || props["aria-label"]
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "100%",
    viewBox: "-1 -1 2 2"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "rotate(-90)"
  }, data.filter(function (item) {
    return item.value > 0;
  }).map(function (item) {
    // Add some nice hover/focus styles when we're integrated with a
    // legend
    var propsWithLegend = legend ? {
      onMouseEnter: function onMouseEnter() {
        return legend.setHover(item.key);
      },
      onMouseLeave: function onMouseLeave() {
        return legend.setHover();
      },
      fillOpacity: t("dataOpacity", legend.getState(item.key)) / 100,
      strokeOpacity: t("dataOpacity", legend.getState(item.key)) / 100
    } : {};
    return /*#__PURE__*/_react["default"].createElement("path", (0, _extends2["default"])({
      key: item.key,
      d: paths[item.key],
      fill: item.color,
      onClick: item.onClick ? function () {
        return item.onClick(item);
      } : undefined,
      className: item.onClick ? clickablePathStyles : undefined
    }, propsWithLegend));
  }))), props.children ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, props.children)) : null);
};

Pie.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The id of an element that acts as a description for the visualization.
   * We recommend displaying a Text component with a description for
   * the visualization and setting this prop to the id of that Text.
   *
   * This will be ignored if the same prop is set on `LegendProvider`.
   *
   * @since 5.20.0
   */
  "aria-describedby": _propTypes["default"].string,

  /**
   * A label for the visualization. We recommend using `aria-labelledby` and
   * `aria-describedby` if possible, otherwise this can be set if there is no
   * visible element that labels the visualization.
   *
   * This will be ignored if the same prop is set on `LegendProvider`.
   */
  "aria-label": _propTypes["default"].string,

  /**
   * The id of an element that acts as a label, heading, or title for the
   * visualization. We recommend displaying a Heading component with a title for
   * the visualization and setting this prop to the id of that Heading.
   *
   * This will be ignored if the same prop is set on `LegendProvider`.
   */
  "aria-labelledby": _propTypes["default"].string,

  /**
   * Places a border based on token color around the data viz component
   * and it's segments.
   *
   * @since 5.21.0
   */
  border: _propTypes["default"].oneOf(["primary", "secondary", "alternatePrimary", "alternateSecondary", "inverted"]),

  /**
   * Use this in combination with the `donutRatio` prop to render content inside
   * of a donut.
   */
  children: _propTypes["default"].node,

  /**
   * An array of colors to use in the visualization. The colors will be assigned
   * to data items according to their order in the array. If there are more data
   * items than colors then colors will be reused (also according to their order
   * in the array).
   *
   * If a color is defined for a data item via the `color` field in the item's
   * object then this color scale will be ignored for that item.
   *
   * This will be ignored if the same prop is set on `LegendProvider`.
   */
  colorScale: _propTypes["default"].arrayOf(_propTypes["default"].string),

  /**
   * An array of data for the visualization. Each item in the array must be an
   * object with a `value` field containing the value of that item in the
   * visualization. The percentage of the pie taken up by each item is
   * calculated based off of the total of all the item values.
   *
   * An optional `color` field is allowed that will override the color
   * prescribed by the `colorScale` prop.
   *
   * An optional `onClick` function can be attached to an individual segment. When
   * pressed, the function will be called with the original data item as its only
   * argument. Use with the `Legend` and `LegendProvider` to ensure user's using
   * assistive technologies like screen readers are able to access and understand
   * the interaction.
   *
   * A unique `key` field should also be provided if the data objects may change
   * after the component is mounted (this field will be used as the item's React
   * key).
   *
   * This will be ignored if the same prop is set on `LegendProvider`.
   */
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].number.isRequired,
    key: _propTypes["default"].string,
    color: _propTypes["default"].string,
    onClick: _propTypes["default"].func
  })),

  /**
   * Use this to render a donut instead of a pie. The ratio represents the
   * width of hole in the middle of the slices relative to the width of the
   * slices. 0 = no hole, all slices. 0.5 = half hole, half slices. 0.9 = 90%
   * hole, 10% slices.
   */
  donutRatio: _propTypes["default"].number,

  /**
   * The width (and height...) of the pie.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
} : {};
Pie.defaultProps = {
  donutRatio: 0
};
var _default = Pie;
exports["default"] = _default;